define('drops/modalAction/ModalActionSpa',[
    'jquery',
    'lq',
    'drops/action/action',
    'lq/navigatorSpa',
    'lq/validatorGateway',
    'lq/actionLoader',
    'lq/highlighter'
], function ($, lq, Action, NavigatorSpa, validatorGateway, ActionLoader, highlighter) {
    'use strict';

    var ModalActionSpa = function (modalAction) {
        this.modalAction = modalAction;
        this.onActionLoaded = this.showAction.bind(this);
        this.onEventReceived = this.receiveEvent.bind(this);
    };
    
    ModalActionSpa.prototype.setUp = function () {
        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo(this.modalAction.$element)
            .css({
                width: '100%',
                height: '100%',
                border: 0,
                display: 'none',
                overflow: this.modalAction.data.scrolling === 'auto'
                    ? 'auto'
                    : 'hidden'
            });
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);
    };

    ModalActionSpa.prototype.show = function (actionId) {
        if (!actionId) return;

        var globals = this.modalAction.piping.parameters.globals.getAll();
        var locals = this.modalAction.getParametersForIframe();

        this.navigator = NavigatorSpa.inMemory(actionId, this.modalAction.piping.url, this.openNewAction.bind(this));
        this.actionLoader = new ActionLoader(this.modalAction.piping.url);
        this.actionLoader.addListener(this.onActionLoaded);

        this.openNewAction(actionId, globals, locals);
    };

    ModalActionSpa.prototype.showAction = function (setup, parameters) {
        this.$wrapper.css('display', 'inherit');

        var action = new Action(setup.action.view, this.modalAction.piping.application.options);
        action.backgroundDrops = setup.action.backgroundDrops;
        action.allLayouts = setup.action.allLayouts;
        action.defaultLayout = setup.action.defaultLayout;
        action.piping = this.modalAction.piping.createChildPiping(setup.action, parameters, action, this.$wrapper, this.$view, false);
        action.piping.navigator = this.navigator;
        action.piping.eventing.addIntercept(this.onEventReceived);
        action.globals = _.clone(parameters.globals);
        action.locals = _.clone(parameters.locals);

        action.createAndRenderDrops($());

        if (this.modalAction.$element.css('position') === 'relative' || this.modalAction.data.useSelectedActionSize) {
            this.modalAction.$element.height('auto');

            // why did we ever start using absolute positioning???
            if (this.modalAction.data.useSelectedActionSize) {
                if (!action.canGrow()) {
                    var height = (action.data.top || 0) + action.data.size.y + (action.data.bottom || 0);
                    this.modalAction.$element.height(height);
                }

                var width = (action.data.left || 0) + action.data.size.x + (action.data.right || 0);
                this.modalAction.$element.width(width);
            }

            // backwards compatibility fix in case both the modal and the nested action are anchored left + right
            // in the MPA we use an iframe which has (in most browsers) a default width of 300px
            if ($.isNumeric(this.modalAction.data.left)
                && $.isNumeric(this.modalAction.data.right)
                && $.isNumeric(setup.action.view.data.left)
                && $.isNumeric(setup.action.view.data.right))
                this.modalAction.$element.css('width', '300px');
            else if (!this.modalAction.data.useSelectedActionSize)
                this.modalAction.$element.width('auto');
        }

        this.cleanupCurrentAction();

        this.action = action;
        this.action.piping.busyIndicator.forceHide();
        
        validatorGateway.registerListener(action.instanceId, this.receiveMessage.bind(this));

        validatorGateway.publishEvent({
            type: 'ACTION_INSTANCE_LOADED',
            action: action,
            parentInstanceId: this.modalAction.rootDrop.instanceId
        });

        this.$wrapper.scrollTop(0);
    };

    ModalActionSpa.prototype.receiveMessage = function (message) {
        var self = this;

        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.openNewAction(this.action.data.id, this.action.globals, this.action.locals);
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    ModalActionSpa.prototype.openNewAction = function(actionId, globals, locals) {
        this.actionLoader.load(actionId, globals, locals);
    };

    ModalActionSpa.prototype.hide = function () {
        if (!this.$wrapper) return;

        this.$wrapper.css('display', 'none');
    };

    ModalActionSpa.prototype.triggerEventForChild = function (eventObj) {
        if (!this.action) return;

        this.action.triggerEvent(eventObj.eventName, eventObj.args[0]);
    };

    ModalActionSpa.prototype.onError = function (errorArgs) {
        if (this.action)
            this.action.onError(errorArgs);
    };

    ModalActionSpa.prototype.receiveEvent = function (e) {
        // staying backwards compatible with existing custom code
        var args = e.args ? e.args[0] : null;
        this.modalAction.triggerEvent(this.modalAction.data.id + '.' + e.eventName, args);
    };

    ModalActionSpa.prototype.cleanupCurrentAction = function() {
        if (!this.action) return;

        validatorGateway.publishEvent({
            type: 'ACTION_INSTANCE_UNLOADING',
            action: this.action
        });

        this.action.piping.eventing.removeIntercept(this.onEventReceived);
        this.action.unsubscribeEventHandlersRecursive();

        validatorGateway.unregisterListener(this.action.instanceId);

        this.action = null;        
    };

    ModalActionSpa.prototype.dispose = function () {
        this.cleanupCurrentAction();

        if (this.actionLoader) {
            this.actionLoader.removeListener(this.onActionLoaded);
            this.actionLoader = null;
        }
    };

    return ModalActionSpa;
});

